import { render, staticRenderFns } from "./IdentityData.vue?vue&type=template&id=f7b06c24&"
import script from "./IdentityData.vue?vue&type=script&lang=js&"
export * from "./IdentityData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports